import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductPaymentPageRoutingModule } from './product-payment-routing.module';

import { ProductPaymentPage } from './product-payment.page';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ProductPaymentPageRoutingModule,
    NgxIntlTelInputModule
  ],
  declarations: [ProductPaymentPage]
})
export class ProductPaymentPageModule {}
